<template>
  <section class="comm-page dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>
    <section class="dp-right">
      <CommFilterBar :buttonList="buttonList" :searchList="searchList" @callFunction="callFunction" />
      <div class="comm-panel">
        <div class="tbl-scroll-host">
          <el-table
            class="comm-table"
            empty-text="暂无数据"
            :data="rows"
            v-loading="loading"
            size="small"
            height="100%"
            style="width: 100%">
            <el-table-column prop="RuleName" label="套餐" min-width="100" show-overflow-tooltip />
            <el-table-column prop="StudentName" label="姓名" width="88" show-overflow-tooltip />
            <el-table-column prop="StudentNo" label="学号" width="100" show-overflow-tooltip />
            <el-table-column prop="CardNumber" label="卡号" width="110" show-overflow-tooltip />
            <el-table-column prop="ClassName" label="班级" min-width="100" show-overflow-tooltip />
            <el-table-column label="年月" width="88" align="center">
              <template slot-scope="scope">{{ formatYearMonth(scope.row.YearMonth != null ? scope.row.YearMonth : scope.row.yearMonth) }}</template>
            </el-table-column>
            <el-table-column label="分配/已用/剩" width="120" align="center">
              <template slot-scope="scope">
                <span class="comm-mono">{{ scope.row.AllocatedMinutes }}/{{ scope.row.UsedMinutes }}/{{ scope.row.RemainMinutes }}</span>
              </template>
            </el-table-column>
            <el-table-column label="到期" width="148" show-overflow-tooltip>
              <template slot-scope="scope">{{ formatExpire(scope.row.ExpireTime) }}</template>
            </el-table-column>
            <el-table-column label="状态" width="96" align="center">
              <template slot-scope="scope">
                <el-tag size="mini" :type="quotaStatusTagType(scope.row)">{{ quotaStatusText(scope.row) }}</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="comm-pager">
          <el-pagination
            layout="total, prev, pager, next, jumper"
            :current-page="page"
            :page-size="pageSize"
            :total="total"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import './styles/comm-page.css'
import CommFilterBar from './components/CommFilterBar.vue'
import DepartmentPane from '../../components/DepartmentPane'
import { getCommRuleOptions, getCommRuleQuotaListPage, exportCommRuleQuota } from '../../api/modules/misc'

const defaultButtons = [
  { name: '查询', Func: 'handleQuery' },
  { name: '导出', Func: 'handleExport', plain: true }
]

const statusFilterOptions = [
  { label: '全部', value: '' },
  { label: '生效中', value: 1 },
  { label: '已用尽', value: 2 },
  { label: '已过期', value: 3 },
  { label: '随绑定解绑', value: 4 }
]

/** 当前年月 yyyy-MM。创建于 2026-08-07 */
function currentYearMonth() {
  const now = new Date()
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
}

export default {
  components: { CommFilterBar, DepartmentPane },
  data() {
    return {
      loading: false,
      rows: [],
      page: 1,
      pageSize: 10,
      total: 0,
      departmentId: '',
      filters: {},
      searchList: [
        { label: '套餐', key: 'ruleId', type: 'select', initValue: '', options: [{ label: '全部', value: '' }], width: '130px' },
        { label: '月份', key: 'yearMonth', type: 'month', initValue: currentYearMonth(), width: '128px' },
        { label: '姓名', key: 'studentName', initValue: '', width: '110px', placeholder: '姓名' },
        { label: '学号', key: 'studentNo', initValue: '', width: '110px', placeholder: '学号' },
        { label: '卡号', key: 'cardNumber', initValue: '', width: '120px', placeholder: '卡号' },
        { label: '状态', key: 'status', type: 'select', initValue: '', options: statusFilterOptions, width: '110px' }
      ],
      ruleOptions: [{ label: '全部', value: '' }],
      buttonList: []
    }
  },
  methods: {
    formatYearMonth(val) {
      const s = String(val == null ? '' : val).trim()
      if (s.length === 6 && /^\d{6}$/.test(s)) return `${s.slice(0, 4)}-${s.slice(4, 6)}`
      if (s.length === 7 && /^\d{4}-\d{2}$/.test(s)) return s
      return s || '—'
    },
    toYearMonthParam(val) {
      if (val == null || val === '') return ''
      const digits = String(val).replace(/\D/g, '')
      return digits.length === 6 ? digits : ''
    },
    formatExpire(val) {
      if (val == null || val === '') return ''
      const s = String(val).replace('T', ' ')
      return s.length >= 16 ? s.slice(0, 16) : s
    },
    parseExpireTime(val) {
      if (val == null || val === '') return null
      const dt = new Date(String(val).replace(/-/g, '/'))
      return Number.isNaN(dt.getTime()) ? null : dt
    },
    quotaStatusText(row) {
      if (!row || typeof row !== 'object') return ''
      const s = Number(row.Status != null ? row.Status : row.status)
      if (s === 4) return '随绑定解绑'
      if (s === 2) return '已用尽'
      if (s === 3) return '已过期'
      const exp = this.parseExpireTime(row.ExpireTime != null ? row.ExpireTime : row.expireTime)
      if (s === 1 && exp && exp.getTime() < Date.now()) return '已过期'
      if (s === 1) return '生效中'
      return String(row.Status != null ? row.Status : row.status)
    },
    quotaStatusTagType(row) {
      const text = this.quotaStatusText(row)
      if (text === '生效中') return 'success'
      if (text === '已用尽') return 'info'
      if (text === '已过期') return 'warning'
      if (text === '随绑定解绑') return 'danger'
      return 'info'
    },
    callFunction(item) {
      this.filters = typeof item.search === 'object' ? item.search : {}
      if (typeof this[item.Func] === 'function') this[item.Func]()
    },
    treeNodeClick(data) {
      this.departmentId = data && data.value ? data.value : ''
      this.loadRuleOptions()
      this.page = 1
      this.handleQuery()
    },
    getRuleSearchItem() {
      return (this.searchList || []).find((x) => x.key === 'ruleId')
    },
    async loadRuleOptions() {
      const ruleItem = this.getRuleSearchItem()
      if (!this.departmentId) {
        this.ruleOptions = [{ label: '全部', value: '' }]
        if (ruleItem) ruleItem.options = this.ruleOptions
        this.filters.ruleId = ''
        return
      }
      try {
        const res = await getCommRuleOptions({ departmentId: this.departmentId })
        if (res.data.success) {
          const rows = res.data.response || []
          this.ruleOptions = [{ label: '全部', value: '' }].concat(rows.map((x) => ({ label: x.RuleName, value: x.Id })))
          if (ruleItem) ruleItem.options = this.ruleOptions
          const hasCurrent = this.ruleOptions.some((x) => String(x.value) === String(this.filters.ruleId || ''))
          if (!hasCurrent) this.filters.ruleId = ''
        } else {
          this.ruleOptions = [{ label: '全部', value: '' }]
          if (ruleItem) ruleItem.options = this.ruleOptions
        }
      } catch (e) {
        this.ruleOptions = [{ label: '全部', value: '' }]
        if (ruleItem) ruleItem.options = this.ruleOptions
      }
    },
    handleCurrentChange(page) {
      this.page = page
      this.handleQuery()
    },
    buildQueryParams() {
      const params = {
        page: this.page,
        pageSize: this.pageSize,
        ruleId: this.filters.ruleId || '',
        studentName: this.filters.studentName || '',
        studentNo: this.filters.studentNo || '',
        cardNumber: this.filters.cardNumber || '',
        departmentId: this.departmentId || ''
      }
      const rawYm = Object.prototype.hasOwnProperty.call(this.filters || {}, 'yearMonth')
        ? this.filters.yearMonth
        : currentYearMonth()
      const yearMonth = this.toYearMonthParam(rawYm)
      if (yearMonth) params.yearMonth = yearMonth
      const st = this.filters.status
      if (st !== '' && st !== null && st !== undefined) params.status = Number(st)
      return params
    },
    async handleQuery() {
      this.loading = true
      try {
        const res = await getCommRuleQuotaListPage(this.buildQueryParams())
        if (res.data.success) {
          const pageData = res.data.response || {}
          this.rows = pageData.data || []
          this.total = pageData.dataCount || 0
        } else {
          this.$message.error(res.data.msg || '查询失败')
        }
      } finally {
        this.loading = false
      }
    },
    async handleExport() {
      const res = await exportCommRuleQuota(this.buildQueryParams())
      const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `话机配额_${new Date().getTime()}.xlsx`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    }
  },
  mounted() {
    this.buttonList = defaultButtons
    const ruleItem = this.getRuleSearchItem()
    if (ruleItem) ruleItem.options = this.ruleOptions
  }
}
</script>
